
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';

export const WalletBadge: React.FC = () => {
    const [balance, setBalance] = useState<number | null>(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchWallet = async () => {
        try {
            const res = await api.get('/payment/wallet');
            setBalance(res.data.balance);
        } catch (error) {
            console.error('Failed to fetch wallet info', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWallet();

        // Listen for balance updates (e.g. after purchase)
        const handleFocus = () => fetchWallet();
        window.addEventListener('focus', handleFocus);
        return () => window.removeEventListener('focus', handleFocus);
    }, []);

    if (loading) return null;

    return (
        <motion.div
            className="flex items-center gap-2 bg-navy-900/80 border border-gold-500/30 rounded-full px-3 py-1 cursor-pointer hover:bg-navy-800 transition-colors shadow-lg backdrop-blur-sm"
            onClick={() => navigate('/shop')}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
        >
            <span className="text-xl">🪙</span>
            <span className="font-mono font-bold text-gold-400 text-sm">
                {balance !== null ? balance : '-'} SC
            </span>
            <motion.div
                className="w-4 h-4 rounded-full bg-gold-500 text-navy-950 flex items-center justify-center text-[10px] font-bold"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ repeat: Infinity, duration: 2 }}
            >
                +
            </motion.div>
        </motion.div>
    );
};
